export const CONNECTION_STATE_INITIAL = 'initial';
export const CONNECTION_STATE_CONNECTING = 'connecting';
export const CONNECTION_STATE_CONNECTED = 'connected';
export const CONNECTION_STATE_DISCONNECTED = 'disconnected';
export const CONNECTION_STATE_DISCONNECTED_BY_SERVER = 'disconnected_by_server';
export const CONNECTION_STATE_STALLED = 'stalled';
export const CONNECTION_STATE_RECONNECTING = 'reconnecting';


// WEBPACK FOOTER //
// ./src/constants/connectionState.js